export enum TransferVerificationType {
  ProductStoreOrigin = 'product-store-origin',
  ProductStoreDestination = 'product-store-destination',
  LostProduct = 'lost-product',
}
